export default function Home(){
    return(
        <p>NewEvent</p>
    )
    }